/**
 * @file VideoLinkImageOverlay/constants.js
 * @copyright 2020 CBC/Radio-Canada. All rights reserved.
 * @author Avi Craimer [avi.craimer@cbc.ca]
 */
export const baseClass = "videoLinkImageOverlay";

export const playBtn = (
    <svg
        className={baseClass + "PlayBtn"}
        width="34px"
        height="34px"
        viewBox="0 0 34 34"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        data-testid={baseClass + "PlayBtn"}
    >
        <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g
                transform="translate(-49.000000, -1009.000000)"
                fillRule="nonzero"
            >
                <g transform="translate(49.000000, 1009.000000)">
                    <g id="Group-Copy-31">
                        <circle
                            fill="#FFFFFF"
                            cx="16.5"
                            cy="16.5"
                            r="16.5"
                        ></circle>
                        <path
                            d="M12.0627845,9.87071431 L24.510661,16.6074648 C24.6396791,16.677289 24.6876652,16.8384825 24.617841,16.9675006 C24.5925502,17.0142319 24.553825,17.0523041 24.5066704,17.0767967 L12.0587939,23.5423393 C11.9286072,23.6099595 11.768253,23.5592393 11.7006328,23.4290526 C11.6809874,23.3912301 11.6707317,23.3492356 11.6707317,23.3066154 L11.6707317,10.1043222 C11.6707317,9.95762156 11.7896561,9.8386972 11.9363567,9.8386972 C11.9805052,9.8386972 12.0239575,9.84970124 12.0627845,9.87071431 Z"
                            fill="#000000"
                        ></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const captionsIcon = (
    <svg
        className="captions"
        viewBox="0 0 14 9.5"
        width="13px"
        height="13px"
        aria-label="Close captions available"
        data-testid="captions-icon"
    >
        <path d="m12.5,0c0.6875,0 1.25,0.5625 1.25,1.25l0,7.5c0,0.6875 -0.5625,1.25 -1.25,1.25l-8.75,0c-0.69375,0 -1.25,-0.5625 -1.25,-1.25l0,-7.5c0,-0.6875 0.55625,-1.25 1.25,-1.25l8.75,0zm-5,4.375l0,-0.625c0,-0.34375 -0.28125,-0.625 -0.625,-0.625l-1.875,0c-0.34375,0 -0.625,0.28125 -0.625,0.625l0,2.5c0,0.34375 0.28125,0.625 0.625,0.625l1.875,0c0.34375,0 0.625,-0.28125 0.625,-0.625l0,-0.625l-0.9375,0l0,0.3125l-1.25,0l0,-1.875l1.25,0l0,0.3125l0.9375,0zm4.375,0l0,-0.625c0,-0.34375 -0.28125,-0.625 -0.625,-0.625l-1.875,0c-0.34375,0 -0.625,0.28125 -0.625,0.625l0,2.5c0,0.34375 0.28125,0.625 0.625,0.625l1.875,0c0.34375,0 0.625,-0.28125 0.625,-0.625l0,-0.625l-0.9375,0l0,0.3125l-1.25,0l0,-1.875l1.25,0l0,0.3125l0.9375,0z" />
    </svg>
);
